var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSentIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 18 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16.97.888c.23.248.29.612.15.919l-6.23 13.281a.832.832 0 0 1-.69.475.817.817 0 0 1-.75-.367L7.9 12.878l-2.33 1.333a.831.831 0 0 1-.83-.003.839.839 0 0 1-.41-.718V9.465L1.09 8.024a.843.843 0 0 1-.5-.778.836.836 0 0 1 .53-.754L16.06.681a.832.832 0 0 1 .91.207Zm-10.98 9.38.26.131.73 1.095-.99.566v-1.792Zm1.92-.366 2.1 3.147 3.94-8.392-6.04 5.245Zm4.31-5.946-8.64 3.36 1.92.851.03.016 1.16.581 5.53-4.808Z",
  fill: "currentColor"
})));
export { SvgSentIcon as ReactComponent };
export default __webpack_public_path__ + "images/sent-icon.svg";